import React from 'react';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { useHistory } from 'react-router';

const useCapacitor = () => {
  const router = useHistory();

  React.useEffect(() => {
    let listener: any;
    if (Capacitor.isNativePlatform()) {
      //   console.log("NAive!!!!!!!!!");
      listener = App.addListener('backButton', ({ canGoBack }) => {
        // const have_stacks = window.history.length;
        // alert("Stacks::" + have_stacks);
        !canGoBack ? App.exitApp() : router.goBack();
      });
    }

    return () => {
      listener?.remove && listener?.remove();
    };
  }, [router]);
};

export default useCapacitor;
